import _ from 'underscore';

export const DynamicSearchAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Dynamic Search Ad',
    },
    TextPart2: {
      'bulk-upload-header': 'Text Part 2',
    },
    DisplayUrl: {
      'bulk-upload-header': 'Domain',
    },
    Path1: {
      'bulk-upload-header': 'Path 1',
    },
    Path2: {
      'bulk-upload-header': 'Path 2',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    DevicePreference: {
      'bulk-upload-header': 'Device Preference',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
  },
};
